__webpack_require__.p = "/delaklo-platform/";